import { LandingMenuResponse } from "../types/menu";

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8080';

interface CMSContent {
  id: string;
  created_at: string;
  updated_at: string;
  title: string;
  slug: string;
  content: string;
  is_active: boolean;
  version: number;
}

export const cmsApi = {
  async getPrivacyPolicy(): Promise<CMSContent> {
    const response = await fetch(
      `${API_BASE_URL}/api/v1/clients/cms/content/privacy-policy`
    );
    if (!response.ok) {
      throw new Error("Error fetching privacy policy");
    }
    return response.json();
  },

  async getTermsAndConditions(): Promise<CMSContent> {
    const response = await fetch(
      `${API_BASE_URL}/api/v1/clients/cms/content/terms-conditions`
    );
    if (!response.ok) {
      throw new Error("Error fetching terms and conditions");
    }
    return response.json();
  },

  async getLandingMenu(): Promise<LandingMenuResponse> {
    const response = await fetch(`${API_BASE_URL}/api/v1/menu/landing-menu`);
    if (!response.ok) {
      throw new Error("Error fetching landing menu");
    }
    return response.json();
  },
};
